import { useState } from 'react';
import type { Params } from './formacion-precios/types';
import { ParamsPanel } from './formacion-precios/ParamsPanel';
import { TablaPublicaciones } from './formacion-precios/TablaPublicaciones';
import { Calculadora } from './formacion-precios/Calculadora';
import { CostosVistaPrevia } from './formacion-precios/CostosVistaPrevia';
import { PreciosPorPublicacion } from './formacion-precios/PreciosPorPublicacion';
import { ParametrosPrecios } from './formacion-precios/Parametros';
import { VerInstructivo } from '../components/VerInstructivo';

// ─── Página principal ──────────────────────────────────────────────────────
type TabPrecios = 'publicacion' | 'tabla' | 'calculadora' | 'costos' | 'parametros';

const TABS_PRECIOS: Array<{ id: TabPrecios; label: string }> = [
  { id: 'publicacion', label: '🏷️ Por publicación' },
  { id: 'tabla',       label: '📋 Publicaciones' },
  { id: 'calculadora', label: '🧮 Calculadora' },
  { id: 'costos',      label: '🔎 Costos (vista previa)' },
  { id: 'parametros',  label: '⚙️ Parámetros' },
];

export function FormacionPreciosPage() {
  const [tab, setTab] = useState<TabPrecios>('publicacion');
  const [params, setParams] = useState<Params>({
    rentabilidadPct: 20,
    ivaAlicuota: 21,
    tipo: 'premium',
    costoConIva: true,
  });

  return (
    <div className="p-6 max-w-7xl mx-auto space-y-5">
      {/* Header */}
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <h1 className="text-2xl font-bold text-slate-800 inline">Formación de precios</h1><VerInstructivo seccion="formacion-de-precios" />
          <p className="text-sm text-slate-500 mt-0.5">Precios sugeridos en base a costos del catálogo y fees de MercadoLibre.</p>
        </div>
        <div className="flex flex-wrap rounded-lg border border-slate-200 bg-white overflow-hidden">
          {TABS_PRECIOS.map(t => (
            <button key={t.id} onClick={() => setTab(t.id)}
              className={`px-5 py-2 text-sm font-medium transition-colors ${tab === t.id ? 'bg-brand-500 text-white' : 'text-slate-600 hover:bg-slate-50'}`}>
              {t.label}
            </button>
          ))}
        </div>
      </div>

      {tab === 'publicacion' ? (
        // Precio sugerido por publicación: usa los parámetros guardados, no los de la calculadora.
        <PreciosPorPublicacion />
      ) : tab === 'parametros' ? (
        <ParametrosPrecios />
      ) : tab === 'costos' ? (
        // Sección aparte: no usa los parámetros de precio ni la calculadora.
        <CostosVistaPrevia />
      ) : (
        <>
          {/* Parámetros */}
          <ParamsPanel p={params} setP={setParams} />

          {/* Contenido */}
          {tab === 'tabla' ? <TablaPublicaciones p={params} /> : <Calculadora p={params} />}
        </>
      )}
    </div>
  );
}
